import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const logs = {
  fetchLogs: async (refId: number, source: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get(
        `/logs?refId=${refId}&source=${source}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  addLog: async (data: {
    ref_id: number;
    source: string;
    log: string;
    company_id?: number | null;
  }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/logs', data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default logs;
